import React from 'react';
import GameSwiper from "./GameSwiper";
import styles from "./GameCatalog.module.css";

const GamesCatalog = () => {

    return (
        <div id='section2' className={styles.catalog_container}>
            <div className={styles.titles}>
                <h2>Величезна <span style={{color: 'red'}}>бібліотека ігор</span> завжди під рукою!</h2>
                <p>Більше можливостей - більше задоволення</p>
                <div>
                    <ul >
                        <li className={styles.li1}>Всі ігри підписок PS Plus, EA Play, Xbox Game Pass Ultimate</li>
                        <li className={styles.li2}>Нескінченний доступ до ігор</li>
                        <li className={styles.li3}>Нові релізи щомісяця</li>
                    </ul>
                </div>
            </div>
            <GameSwiper quantity={4}/>
        </div>
    );
};

export default GamesCatalog;